export default __webpack_public_path__ + "static/media/nutrilon_achis.2fbda3ca.jpg";